import {
  Drawer,
  Box,
  Typography,
  TextField,
  MenuItem,
  Checkbox,
  Button,
  CircularProgress
} from '@mui/material';

import { useState, useEffect } from 'react';

export default function SpaPromotionModal({
  open,
  onClose,
  editData,
  spaItems,
  selectedSpaItemId,
  setSelectedSpaItemId,
  onSubmit,
  loading
}) {
  const [form, setForm] = useState({
    title: '',
    description: '',
    discount: '',
    startDate: '',
    endDate: '',
    status: 'active'
  });

  useEffect(() => {
    if (open && editData) {
      console.log("📋 Incoming editData:", editData);
      setForm({
        title: editData.title || '',
        description: editData.description || '',
        discount: editData.discount?.toString() || '',
        startDate: editData.startDate ? editData.startDate.substring(0, 10) : '',
        endDate: editData.endDate ? editData.endDate.substring(0, 10) : '',
        status: editData.status || 'active'
      });
      setSelectedSpaItemId(editData.massageItems || []);
    }
  }, [open, editData, setSelectedSpaItemId]);

  useEffect(() => {
    if (!open) {
      setForm({
        title: '',
        description: '',
        discount: '',
        startDate: '',
        endDate: '',
        status: 'active'
      });
      setSelectedSpaItemId([]);
    }
  }, [open, setSelectedSpaItemId]);

  // Debugging: monitor date field behavior
  
  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box sx={{ width: 600, p: 3 }}>
        <Typography variant="h6" gutterBottom>
          {editData ? 'Edit Promotion' : 'Create Promotion'}
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField
            label="Promotion Title"
            fullWidth
            value={form.title}
            onChange={(e) => setForm({ ...form, title: e.target.value })}
          />
          <TextField
            label="Description"
            fullWidth
            multiline
            rows={2}
            value={form.description}
            onChange={(e) => setForm({ ...form, description: e.target.value })}
          />
          <TextField
            select
            SelectProps={{
              multiple: true,
              renderValue: (selected) =>
                spaItems
                  .filter((item) => selected.includes(item._id))
                  .map((item) => item.typeOfMassage || item.name || item.title || 'Unnamed Item')
                  .join(', ')
            }}
            label="Item"
            fullWidth
            value={selectedSpaItemId}
            onChange={(e) => {
              const value = e.target.value;
              if (value.includes("__all__")) {
                const allIds = spaItems.map(item => item._id);
                setSelectedSpaItemId(allIds);
              } else {
                setSelectedSpaItemId(value);
              }
            }}
          >
            <MenuItem value="__all__">
              <Checkbox checked={selectedSpaItemId.length === spaItems.length} />
              Select All
            </MenuItem>
            {spaItems.map((item) => (
              <MenuItem key={item._id} value={item._id}>
                <Checkbox checked={selectedSpaItemId.includes(item._id)} />
                {item.typeOfMassage || item.name || item.title || 'Unnamed Item'}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            label="Discount (%)"
            type="number"
            fullWidth
            value={form.discount}
            onChange={(e) => setForm({ ...form, discount: e.target.value })}
          />
          <TextField
            label="Start Date"
            type="date"
            InputLabelProps={{ shrink: true }}
            fullWidth
            value={form.startDate}
            onChange={(e) => setForm({ ...form, startDate: e.target.value })}
          />
          <TextField
            label="End Date"
            type="date"
            InputLabelProps={{ shrink: true }}
            fullWidth
            value={form.endDate}
            onChange={(e) => setForm({ ...form, endDate: e.target.value })}
          />
          <TextField
            select
            label="Status"
            fullWidth
            value={form.status}
            onChange={(e) => setForm({ ...form, status: e.target.value })}
          >
            <MenuItem value="active">Active</MenuItem>
            <MenuItem value="inactive">Inactive</MenuItem>
          </TextField>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
            <Button onClick={onClose}>Cancel</Button>
            <Button
              variant="contained"
              onClick={() => {
                const parsedDiscount = parseFloat(form.discount);
                if (!form.title || isNaN(parsedDiscount)) {
                  console.error('🚫 Missing required fields:', { title: form.title, discount: form.discount });
                  alert('⚠️ Please fill in a valid title and discount.');
                  return;
                }

                onSubmit({
                  title: form.title,
                  description: form.description,
                  discount: parsedDiscount,
                  startDate: form.startDate,
                  endDate: form.endDate,
                  status: form.status,
                  massageItems: selectedSpaItemId
                });
              }}
              disabled={loading}
              startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
            >
              {loading ? 'Saving...' : editData ? 'Update' : 'Save'}
            </Button>
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
}